import { intersectionViewportObserver } from '../../utilities/intersectionViewportObserver';
import InjectScript from '../../utilities/injectscript';

export const USER_INTERACTION_EVENT_TYPES_ALL = [
  'mousemove',
  'scroll',
  'keyup',
  'keydown',
  'touchstart',
  'click',
];
export const USER_INTERACTION_EVENT_SCROLL = ['scroll', 'touchstart'];

export const userInteractionEvent = (eventTypes, node, onComplete) => {
  eventTypes.forEach((event) => {
    window.addEventListener(event, onComplete);
  });
};

const ON_SCRIPT_LOAD = 'loaded';

export const injectScriptFunction = (value, vnode) => {
  const { async, crossorigin, integrity, name, src } = value;

  InjectScript.injectScript(src, {
    async: async || true,
    crossorigin,
    integrity,
    name,
  }).then(() => {
    if (vnode.componentInstance) {
      vnode.componentInstance.$emit(ON_SCRIPT_LOAD);
    } else {
      vnode.elm.dispatchEvent(new CustomEvent(ON_SCRIPT_LOAD));
    }
  });
};

export const lazyScript = {
  name: 'lazy-script',
  bind: (el, bindings, vnode) => {
    const { value, modifiers } = bindings;
    const onComplete = () => {
      USER_INTERACTION_EVENT_TYPES_ALL.forEach((event) => {
        window.removeEventListener(event, onComplete);
      });

      injectScriptFunction(value, vnode);
    };

    if (modifiers.scroll) {
      userInteractionEvent(USER_INTERACTION_EVENT_SCROLL, vnode, onComplete);
    } else if (modifiers.visible) {
      intersectionViewportObserver(el, { checkIsVisible: true, threshold: [0.006] }).then(() => {
        injectScriptFunction(value, vnode);
      });
    } else {
      userInteractionEvent(USER_INTERACTION_EVENT_TYPES_ALL, vnode, onComplete);
    }
  },
};
